import { ApiMethod, constructFetchFn } from '@utils/api';
import { API } from '@utils/constants';

export const login = (comId, username, password, remember) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.ADMIN_LOGIN,
        body: {
            comId,
            username,
            password,
            remember
        },
    })
);

export const logout = () => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.ADMIN_LOGOUT,
    })
);

export const me = () => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.ADMIN_ME
    })
)

export const programClone = (programId, title) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.PROGRAM_CLONE,
        body: {
            programId,
            title
        }
    })
)

export const programDelete = (programId) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.PROGRAM_DELETE,
        body: {
            programId
        }
    })
)

export const programDetail = (pid) => (
    constructFetchFn({
        method: ApiMethod.GET,
        url: API.PROGRAM_DETAIL,
        pathParams: {
            ':id': pid
        }
    })
);

export const programList = () => (
    constructFetchFn({
        method: ApiMethod.GET,
        url: API.PROGRAM_LIST
    })
);

export const programUpdate = (programId, configuration) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.PROGRAM_UPDATE,
        body: {
            programId,
            configuration
        }
    })
);

export const templateExport = (programId, sectionId) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.TEMPLATE_EXPORT,
        responseType: 'blob',
        body: {
            programId,
            sectionId
        }
    })
)

export const templateImport = (programId, sectionId, file) => {
    const formData = new FormData();
    formData.append('programId', programId);
    formData.append('sectionId', sectionId);
    formData.append('file', file);

    return constructFetchFn({
        method: ApiMethod.POST,
        url: API.TEMPLATE_IMPORT,
        header: {
            'content-type': 'multipart/form-data'
        },
        body: formData

    })
}

export const template = (programId) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.TEMPLATE_VIEW,
        body: {
            programId
        }
    })
)

export const applicationDetail = (programId, applicationNumber) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.APPLICATION_DETAIL,
        body: {
            programId
        },
        pathParams: {
            ':applicationNumber': applicationNumber
        }
    })
);

export const applicationImport = (programId, sectionId, file, attachments = '') => {
    const formData = new FormData();
    formData.append('programId', programId);
    formData.append('sectionId', sectionId);
    formData.append('file', file);
    formData.append('attachments', attachments);

    constructFetchFn({
        method: ApiMethod.POST,
        url: API.APPLICATION_IMPORT,
        header: {
            'content-type': 'multipart/form-data'
        },
        body: formData
    })}


export const applicationConfig = (programId) => (
    constructFetchFn({
         method: ApiMethod.POST,
         url: API.APPLICATION_LIST_CONFIG,
         body: {
             programId
         }
     })
)

export const applicationList = (programId, search = '', filter = {}) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.APPLICATION_LIST,
        body: {
            programId,
            search,
            filter
        }
    })
);

export const paymentGet = (programId, applicationNumber) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.PAYMENT_GET,
        body: {
            programId
        },
        pathParams: {
            ':applicationNumber': applicationNumber
        }
    })
);

export const paymentUpdate = (programId, applicationNumber, status, paymentMethod = '', remarks = '') => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.PAYMENT_UPDATE,
        body: {
            programId,
            applicationNumber,
            status,
            paymentMethod,
            remarks
        }
    })
)

export const adminReceipt = (programId, applicationNumber) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.ADMIN_RECEIPT,
        body: {
            programId
        },
        pathParams: {
            ':applicationNumber': applicationNumber
        }
    })
)

export const applicationUpdate = (programId, applicationNumber, data) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.APPLICATION_UPDATE,
        body: {
            programId,
            applicationNumber,
            data
        }
    })
)

export const fileUpload = (programId, file) => {
    const formData = new FormData();
    formData.append('programId', programId);
    formData.append('file', file);

    return constructFetchFn({
        method: ApiMethod.POST,
        url: API.ADMIN_FILE_UPLOAD,
        header: {
            'content-type': 'multipart/form-data'
        },
        body: formData
    })
}

export const reportDownload = (programId) => (
    constructFetchFn({
        method: ApiMethod.POST,
        responseType: 'blob',
        url: API.ADMIN_REPORT_DOWNLOAD,
        body: {
            programId
        }
    })
)
